<div
  class="modal fade"
  [class.show]="visible"
  [style.display]="visible ? 'block' : 'none'"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Reset Password</h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <form #ResetPasswordForm="ngForm" class="needs-validation" novalidate>
          <!-- New Password -->
          <div class="mb-3">
            <label class="form-label fw-semibold">
              New Password <span class="text-danger">*</span>
            </label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="fa fa-lock"></i>
              </span>
              <input
                name="newPassword"
                [(ngModel)]="entity.newPassword"
                class="form-control"
                [type]="pswType"
                placeholder="Enter new password"
                minlength="8"
                required
                #NewPsw="ngModel"
                [class.is-invalid]="NewPsw.invalid && NewPsw.touched"
              />
              <button type="button" class="input-group-text" (click)="changetype()">
                <i [class]="pswType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
              </button>
            </div>
          </div>

          <!-- Requirements -->
          <div class="mb-3 password-requirements">
            <small class="text-muted d-block mb-2">Password must contain:</small>
            <ul class="requirements-list">
              <li [class.valid]="hasMinLength()">
                <i
                  [class]="
                    hasMinLength()
                      ? 'fa fa-check-circle text-success'
                      : 'fa fa-times-circle text-danger'
                  "
                ></i>
                At least 8 characters
              </li>
              <li [class.valid]="hasUpperCase()">
                <i
                  [class]="
                    hasUpperCase()
                      ? 'fa fa-check-circle text-success'
                      : 'fa fa-times-circle text-danger'
                  "
                ></i>
                One uppercase letter
              </li>
              <li [class.valid]="hasLowerCase()">
                <i
                  [class]="
                    hasLowerCase()
                      ? 'fa fa-check-circle text-success'
                      : 'fa fa-times-circle text-danger'
                  "
                ></i>
                One lowercase letter
              </li>
              <li [class.valid]="hasNumber()">
                <i
                  [class]="
                    hasNumber()
                      ? 'fa fa-check-circle text-success'
                      : 'fa fa-times-circle text-danger'
                  "
                ></i>
                One number
              </li>
              <li [class.valid]="hasSpecialChar()">
                <i
                  [class]="
                    hasSpecialChar()
                      ? 'fa fa-check-circle text-success'
                      : 'fa fa-times-circle text-danger'
                  "
                ></i>
                One special character
              </li>
            </ul>
          </div>

          <!-- Confirm Password -->
          <div class="mb-3">
            <label class="form-label fw-semibold">
              Confirm Password <span class="text-danger">*</span>
            </label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="fa fa-lock"></i>
              </span>
              <input
                name="confirmPassword"
                [(ngModel)]="entity.confirmPassword"
                class="form-control"
                [type]="confirmPswType"
                placeholder="Re-enter password"
                required
                #ConfirmPsw="ngModel"
                [class.is-invalid]="
                  (ConfirmPsw.invalid && ConfirmPsw.touched) ||
                  (passwordMismatch() && ConfirmPsw.touched)
                "
              />
              <button type="button" class="input-group-text" (click)="changeConfirmType()">
                <i [class]="confirmPswType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
              </button>
            </div>
            <div *ngIf="passwordMismatch() && ConfirmPsw.touched" class="invalid-feedback d-block">
              Passwords do not match
            </div>
          </div>

          <!-- Generate Button -->
          <div class="mb-3">
            <button type="button" class="btn btn-primary w-100" (click)="generatePassword()">
              <i class="fa fa-key me-2"></i> Generate Strong Password
            </button>
          </div>

          <!-- Error Message -->
          <div *ngIf="errorMessage" class="alert alert-danger">
            <i class="fa fa-exclamation-triangle me-2"></i>{{ errorMessage }}
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeModal()"
          [disabled]="isLoading"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onSave()"
          [disabled]="!canSave() || isLoading"
        >
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
          {{ isLoading ? 'Saving...' : 'Reset Password' }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop fade" [class.show]="visible" *ngIf="visible"></div>
